import { createApp } from 'vue';
import GallerySlider from '../components/GallerySlider.vue';

function initGallerySlider() {
  const galleryContainer = document.querySelector('.wp-block-group.swiper > .wp-block-gallery');

  if (!galleryContainer) return;

  const imageElements = galleryContainer.querySelectorAll('.wp-block-image img.lazy');

  if (!imageElements.length) return;

  const images = Array.from(imageElements).map((img) => ({
    src: img.src,
    alt: img.alt || ''
  }));

  const parentGroup = galleryContainer.closest('.gallery-wrapper');
  parentGroup.innerHTML = '';

  const mountPoint = document.createElement('div');
  mountPoint.className = 'vue-gallery-slider-mount';
  parentGroup.appendChild(mountPoint);

  createApp(GallerySlider, { images }).mount(mountPoint);

  console.log(`[GallerySlider] Initialized with ${images.length} images`);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGallerySlider);
} else {
  initGallerySlider();
}
